// @flow
import React from 'react';

import owlSpinner from 'assets/images/spinner.gif';

import './styles.css';

type Props = {
    show: boolean,
    message: string
  }

export default (props: Props) => {
  if (props.show === true) {
    return (
      <div className="covering-loader">
        <img alt="loader" src={owlSpinner} className="processing-loader" />
        {props.message ? (
          <p style={{ marginTop: '130px', fontSize: '18px' }}>
            <b>
              {props.message}
              {' '}
            </b>
          </p>
        ) : null}

      </div>
    );
  }

  return null;
};
